import React from 'react';
import aboutDbq from '../assets/images/aboutdbq.png';

const AboutSection = () => {
    const coreStrengths = [
        "Understanding of high-level business requirements.",
        "In depth need Analysis.",
        "Transforming them to Software Products and Services that are User-Friendly."
    ];

    return (
        <section id="about" className="bg-[#0a1d37] text-white py-20 px-4 md:px-0">
            <div className="container mx-auto px-6 md:px-12">
                <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
                    <div className="flex-1 lg:max-w-2xl">
                        <h2 className="text-[#c9a770] text-3xl md:text-4xl font-bold mb-8 md:mb-10 uppercase tracking-wider">
                            About DBQ
                        </h2>

                        <div className="space-y-6 md:space-y-8">
                            <h3 className="text-lg md:text-xl font-medium text-white/90">
                                DBQ - DISTINCTION BY QUALITY
                            </h3>

                            <p className="text-gray-300 leading-relaxed text-sm md:text-[15px] font-light">
                                DBQ was established in the year 2010, in Bangalore
                                India by a group of software professionals.
                            </p>

                            <div className="space-y-4 md:space-y-6">
                                <p className="text-gray-200 font-medium text-sm md:text-base">
                                    Our Core Strength remains to be in :
                                </p>
                                <ul className="space-y-3 md:space-y-4">
                                    {coreStrengths.map((strength, index) => (
                                        <li key={index} className="flex items-start gap-3 text-gray-300 text-sm md:text-[15px] font-light">
                                            <span className="text-[#c9a770] mt-1.5 h-1.5 w-1.5 rounded-full bg-[#c9a770] flex-shrink-0" />
                                            <span>{strength}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="w-full max-w-[300px] lg:w-[450px] flex justify-center lg:justify-end animate-pulse-slow">
                        <img
                            src={aboutDbq}
                            alt="About DBQ Illustration"
                            className="w-full h-auto drop-shadow-2xl"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
